/** WordPress-style URL slug from a name/title */
export function slugify(text) {
  if (!text || typeof text !== 'string') return '';
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/** Append SEO fields from admin forms to FormData */
export function appendSeoToFormData(formData, values = {}) {
  if (!values) return;
  const textFields = [
    'slug', 'seoTitle', 'metaDescription', 'canonicalUrl',
    'ogTitle', 'ogDescription', 'ogImage',
    'twitterTitle', 'twitterDescription', 'twitterImage',
    'featuredImageAlt', 'schemaType',
  ];
  textFields.forEach((field) => {
    if (values[field] !== undefined && values[field] !== '') formData.append(field, values[field]);
  });
  // Keep legacy metaTitle in sync for older product fields
  const title = values.seoTitle || values.metaTitle;
  if (title) {
    formData.append('metaTitle', title);
    if (!values.seoTitle) formData.append('seoTitle', title);
  }
  if (values.robotsIndex === false || values.robotsIndex === 'false') formData.append('robotsIndex', 'false');
  else if (values.robotsIndex === true || values.robotsIndex === 'true') formData.append('robotsIndex', 'true');
  if (values.robotsFollow === false || values.robotsFollow === 'false') formData.append('robotsFollow', 'false');
  else if (values.robotsFollow === true || values.robotsFollow === 'true') formData.append('robotsFollow', 'true');
  if (values.includeInSitemap === false || values.includeInSitemap === 'false') formData.append('includeInSitemap', 'false');
  else if (values.includeInSitemap === true || values.includeInSitemap === 'true') formData.append('includeInSitemap', 'true');
}

export function pickSeoFromEntity(entity = {}) {
  return {
    slug: entity.slug || '',
    seoTitle: entity.seoTitle || entity.metaTitle || '',
    metaTitle: entity.metaTitle || entity.seoTitle || '',
    metaDescription: entity.metaDescription || '',
    canonicalUrl: entity.canonicalUrl || '',
    robotsIndex: entity.robotsIndex !== false,
    robotsFollow: entity.robotsFollow !== false,
    ogTitle: entity.ogTitle || '',
    ogDescription: entity.ogDescription || '',
    ogImage: entity.ogImage || '',
    twitterTitle: entity.twitterTitle || '',
    twitterDescription: entity.twitterDescription || '',
    twitterImage: entity.twitterImage || '',
    featuredImageAlt: entity.featuredImageAlt || '',
    includeInSitemap: entity.includeInSitemap !== false,
    schemaType: entity.schemaType || 'none',
    seoByLocale: entity.seoByLocale || {},
  };
}

export const emptySeoFields = {
  slug: '',
  slugLocked: false,
  seoTitle: '',
  metaDescription: '',
  canonicalUrl: '',
  robotsIndex: true,
  robotsFollow: true,
  ogTitle: '',
  ogDescription: '',
  ogImage: '',
  twitterTitle: '',
  twitterDescription: '',
  twitterImage: '',
  featuredImageAlt: '',
  includeInSitemap: true,
  schemaType: 'none',
};
